import { TextField } from '@mui/material'
import { Controller } from 'react-hook-form'
import RequiredLabel from 'components/RequiredLabel'
import { formatPhoneInput, phoneDigits } from 'utils/phone'


export default function PhoneField({
  name,
  control,
  label,
  required = false,
  valueFormat = 'formatted',
  inputProps,
  ...textFieldProps
}) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <TextField
          fullWidth
          label={required ? <RequiredLabel>{label}</RequiredLabel> : label}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          {...textFieldProps}
          inputProps={{ inputMode: 'tel', maxLength: 14, ...inputProps }}
          name={field.name}
          inputRef={field.ref}
          onBlur={field.onBlur}
          value={formatPhoneInput(field.value ?? '')}
          onChange={event => {
            const digits = phoneDigits(event.target.value)
            field.onChange(valueFormat === 'digits' ? digits : formatPhoneInput(digits))
          }}
        />
      )}
    />
  )
}
